import { IBGECity } from "./statesOfBrazil.types";

export class StatesOfBrazilService {
  async getCitiesByState(uf: string): Promise<IBGECity[]> {
    const response = await fetch(
      `${process.env.REACT_APP_URL_IBGE}/api/v1/localidades/estados/${uf}/municipios`,
    );

    if (!response.ok) {
      throw new Error("Erro ao buscar cidades");
    }

    const data: IBGECity[] = await response.json();

    return data;
  }
}

export const statesOfBrazilService = new StatesOfBrazilService();
